import { useLocation, useNavigate } from "react-router-dom";

import { useGame } from "../header/GameContext";
import KeywordCheck from "./keywordCheck";
import ChatBoxType2 from "../chat/chatType2";
import Header from "../header/header";
import Wrong from "../wrong/wrong";
import Hint from "../hint/hint";
import { useState, useEffect, useRef } from "react";

import "./quiz.css";

/*
1. 퀴즈 정답 데이터 --> correctAnswerDatas 
2. 힌트 여부 ( 있음 었음 ) 
2-1. 있다면 데이터 값 전달 받기 ? vs 데이터값 저장 ? (없다면 무시)
3. 컨포넌트 이동경로 정답이라면 -> 정답 컨퍼넌트 / 오답이라면 오답 컨퍼넌트 / 힌트라면 힌트 컨퍼넌트

*/
export default function Keyword({
  answerData,
  DateVal,
  titImgclassName,
  timerMode = "run",
  showHeader = true,
}) {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { startTimer, pauseTimer, TOTAL_GAME_TIME } = useGame();
  const [showWrong, setShowWrong] = useState(false);

  /* =========================
        타이머 제어 (핵심)
      ========================= */
  useEffect(() => {
    if (timerMode === "run") {
      startTimer();
    } else {
      pauseTimer();
    }
  }, [timerMode]);

  if (state) {
    const { answerDataState, DateValState, titImgclassNameState } = state;
    answerData = answerDataState;
    DateVal = DateValState;
    titImgclassName = titImgclassNameState;
  }

  const chatRef = useRef(null);
  return (
    <div id="content">
      <Header initialTime={TOTAL_GAME_TIME} missionCount={3} missionTotal={8} />
      <div className="box box_con con_box1 con_pd5 con_box_c ans0001">
        <div className="mission_tit keywordInputTit"></div>

        <ChatBoxType2
          DateVal={DateVal}
          titImgClass={titImgclassName}
          ref={chatRef}
        />

        <KeywordCheck
          onWrong={() => setShowWrong(true)}
          answerData={answerData}
        />

        {showWrong && <Wrong onClose={() => setShowWrong(false)} />}
      </div>
    </div>
  );
}
